// src/WithdrawRequests.js
import React, { useEffect, useState } from "react";
import { db } from "./firebase";
import {
  collection,
  getDocs,
  doc,
  updateDoc,
  increment,
  deleteDoc,
  query,
  orderBy,
} from "firebase/firestore";
import "./WithdrawRequests.css";

function toNumber(v, fallback = 0) {
  if (v === null || v === undefined) return fallback;
  const n = Number(v);
  return Number.isNaN(n) ? fallback : n;
}

function toDate(v) {
  // Firestore Timestamp or JS Date or ISO string
  if (!v) return null;
  if (v.seconds) return new Date(v.seconds * 1000);
  if (v.toDate) return v.toDate();
  const d = new Date(v);
  return Number.isNaN(+d) ? null : d;
}

export default function WithdrawRequests() {
  const [requests, setRequests] = useState([]);

  useEffect(() => {
    async function fetchRequests() {
      const q = query(
        collection(db, "withdrawRequests"),
        orderBy("requestedAt", "desc")
      );
      const snapshot = await getDocs(q);
      const rows = snapshot.docs.map((d) => {
        const x = { uid: d.id, ...d.data() };

        // normalize fields
        const points =
          toNumber(x.coinsUsed, null) ??
          toNumber(x.walletPoints, null) ??
          toNumber(x.points, 0);

        const amount =
          toNumber(x.amount, null) ??
          toNumber(x.withdrawalAmount, null) ??
          0;

        const when = toDate(x.requestedAt);
        const upiOrPhone = x.upiOrPhone || x.phone || "";

        return {
          ...x,
          _points: points,
          _amount: amount,
          _when: when,
          _upiOrPhone: upiOrPhone,
        };
      });
      setRequests(rows);
    }
    fetchRequests();
  }, []);

  const handleUpdate = async (req, newStatus) => {
    const requestRef = doc(db, "withdrawRequests", req.uid);
    await updateDoc(requestRef, { status: newStatus });

    if (newStatus === "Completed") {
      // Wallet is tracked in coins/points, so deduct points, not currency.
      const userRef = doc(db, "users", req.userName);
      const pointsToDeduct = toNumber(req._points, 0);
      if (pointsToDeduct > 0) {
        await updateDoc(userRef, { wallet: increment(-pointsToDeduct) });
      }
    }

    setRequests((rs) =>
      rs.map((r) => (r.uid === req.uid ? { ...r, status: newStatus } : r))
    );
  };

  const handleDelete = async (uid) => {
    await deleteDoc(doc(db, "withdrawRequests", uid));
    setRequests((prev) => prev.filter((r) => r.uid !== uid));
  };

  return (
    <div className="withdraw-requests">
      <h2>Withdraw Requests</h2>
      <table>
        <thead>
          <tr>
            <th>User</th>
            <th>Email</th>
            <th>Points</th>
            <th>Amount</th>
            <th>UPI / Phone</th>
            <th>Requested On</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {requests.map((r) => (
            <tr key={r.uid}>
              <td>{r.userName}</td>
              <td>{r.userEmail}</td>
              <td>{r._points}</td>
              <td>{r._amount}</td>
              <td>{r._upiOrPhone}</td>
              <td>{r._when ? r._when.toLocaleString() : ""}</td>
              <td>{r.status}</td>
              <td>
                {r.status === "Pending" ? (
                  <>
                    <button onClick={() => handleUpdate(r, "Completed")}>
                      ✅ Approve
                    </button>
                    <button onClick={() => handleUpdate(r, "Rejected")}>
                      ❌ Reject
                    </button>
                  </>
                ) : (
                  <em>{r.status}</em>
                )}
                <button
                  onClick={() => handleDelete(r.uid)}
                  style={{ marginLeft: 6, background: "#e53935", color: "#fff" }}
                >
                  🗑️ Delete
                </button>
              </td>
            </tr>
          ))}

          {requests.length === 0 && (
            <tr>
              <td colSpan="8" style={{ textAlign: "center" }}>
                No withdrawal requests.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}